import React from 'react';
import numbersHelper from 'helpers';

export interface Props {
  currency: boolean;
  value: number;
}

export default class MetricValue extends React.PureComponent<Props> {
  formatValue() {
    const {currency, value} = this.props;

    if (currency) {
      return numbersHelper.formatPrice(numbersHelper.truncateValue(value, 2));
    }

    return numbersHelper.truncateValue(value, 2);
  }

  render() {
    const {value} = this.props;

    if (value === null) {
      return (
        <span className="shop-tile__metric__value shop-tile__metric__value--light">–</span>
      );
    }

    return (
      <span className="shop-tile__metric__value text-bold">
        {this.formatValue()}
      </span>
    );
  }
}
